import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Navigation, Pagination, Thumbs, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
// import Image from "next/legacy/image";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { isMobileContext } from "../../contexts/isMobileContext";
import { useContext } from "react";
import { BASE_URL } from "../../utils/FetchData";
import ArrowsSpliting from "../Animations/ArrowsSpliting";
import Magnitizer from "../Animations/Magnitizer";
import ReactPlayer from "react-player";
import FadeIn from "../Animations/FadeIn";
import Image from "next/image";

// eslint-disable-next-line react/display-name
const ConstructionUpdates = forwardRef(({ Construction,commercialProject }, ref) => {
	const { locale } = useRouter();
	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	const [isPlaying, setIsPlaying] = useState(false);
	const [activeIndex, setactiveIndex] = useState(0);
	const { isMobile } = useContext(isMobileContext);
	const handlePlayVideo = () => {
		setIsPlaying(!isPlaying);
	};
	return (
		<div className={`${commercialProject&&'commercialProject'} construction-updates-section`} ref={ref}>
			<Swiper
				thumbs={{ swiper: thumbsSwiper }}
				style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
				modules={[Navigation, Pagination, Thumbs, Mousewheel]}

				navigation={{
					nextEl: ".swiper-button-next-construction-updates",
					prevEl: ".swiper-button-prev-construction-updates",
				}}
				className="swiper-construction-updates-section"
				slidesPerView={1}
				onSlideChange={(swiper) => {
					setactiveIndex(swiper.activeIndex);
				}}
			>
				{Construction?.Main_Slider?.map((src, index) => (
					<SwiperSlide key={index}>
						{(src?.Img_Mobile?.data?.attributes?.url || src?.Img_Desktop?.data?.attributes?.url) && <div className={`overlay ${isPlaying ? "hide-overlay" : ""}`}>
							<div className="img-overlay"></div>
							<Image
								src={BASE_URL + (isMobile ? src?.Img_Mobile?.data?.attributes?.url : src?.Img_Desktop?.data?.attributes?.url)}
								alt="banner-image"
								layout="fill"
								objectFit="cover"
							/>
						</div>}
						<div className="icon-shadow-container">
							<Magnitizer
								customClass={`icon ${isPlaying ? "isPlaying" : ""}`}
								dataDest={1.5}
								onClick={() => {
									handlePlayVideo();
								}}
							>
								<div className="player-container" onClick={() => {
									handlePlayVideo();
								}}>
									<ArrowsSpliting xValue={"30%"}>
										{isPlaying ?
											<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
												<path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z" />
											</svg>
											:

											<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" >
												<path d="M23 12l-22 12v-24l22 12zm-21 10.315l18.912-10.315-18.912-10.315v20.63z" />
											</svg>
										}
									</ArrowsSpliting>
								</div>
							</Magnitizer>
						</div>
						{src && src?.Video_Url && <div className="video-container" key={index}>
							<ReactPlayer
								className="video-player"
								playing={isPlaying && index == activeIndex ? true : false}
								url={src?.Video_Url}
								width={"100%"}
								height={"100%"}
								controls={true}
								onEnded={()=>{setIsPlaying(false)}}
							/>
						</div>}
						<FadeIn customClass="header" slideNumber={activeIndex}>
							<h2 className="light _eleX"  style={{ display: isPlaying ? "none" : "flex" }}>{src?.Header1}</h2>
							<h2 className="light _eleX"  style={{ display: isPlaying ? "none" : "flex" }}>{src?.Header2}</h2>
						</FadeIn>
					</SwiperSlide>
				))}
			</Swiper>
			<FadeIn>

			{Construction?.Main_Slider?.length > 1 &&
				<Swiper
					onSwiper={setThumbsSwiper}
					style={{
						direction: locale == "ar" ? "rtl" : "ltr",
						opacity: isPlaying ? 0 : 1,
					}}
					modules={[Navigation, Pagination, Thumbs, Mousewheel]}
					navigation={{
						nextEl: ".swiper-button-next-construction-updates",
						prevEl: ".swiper-button-prev-construction-updates",
					}}
					className="thumbs-swiper"
					slidesPerView={2.75}
					spaceBetween={10}
					breakpoints={{
						1024: {
							slidesPerView: 10,
							spaceBetween: 10,
						},
					}}
				>
					<div className="progress-top">
						<div className="swiper-construction-updates-navigation swiper-pagination-progressbar"></div>
					</div>
					{Construction?.Main_Slider?.map((src, index) => (
						<SwiperSlide key={index}>
							{(src?.Img_Mobile?.data?.attributes?.url || src?.Img_Desktop?.data?.attributes?.url) && 
							<div className={`thumb-container _eleX ${activeIndex==index&&"active"}`} key={index}>
								<div className="overlay"></div>
								{src?.Sub_Slider_Img?.data && <Image
									src={BASE_URL + (isMobile ? src?.Sub_Slider_Img?.data?.attributes?.url : src?.Img_Desktop?.data?.attributes?.url)}
									layout="fill" alt="thumb_img" />}
							</div>}
						</SwiperSlide>
					))}
				</Swiper>
			}
			</FadeIn>
		</div>
	);
});
export default ConstructionUpdates;
